<template>
    <div>
        <div v-for="(contact, i) in contacts">
            <div class="mb-1" style="font-size: 14px; font-weight: 600;">
                {{ contact.first_name }} {{ contact.last_name }} 
                <router-link :to="`/contacts/edit/${contact.id}`" v-if="canEdit" title="Edit Contact"><i class="fa fa-sm fa-edit"></i></router-link>
                <router-link :to="`/contacts/delete/${contact.id}`" v-if="canEdit" title="Delete Contact"><i class="fa fa-sm fa-trash text-danger"></i></router-link>
            </div>
            <div class="text-muted" v-if="contact.title">{{ contact.title }}</div>
            <ul class="list-unstyled mb-0" v-if="contact.emails">
                <li v-for="email in contact.emails">
                    <i class="fa fa-envelope"></i> <a :href="`mailto:${email.email}`">{{ email.email }}</a> <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="email.is_primary">Primary</label>
                </li>
            </ul>
            <ul class="list-unstyled mb-0" v-if="contact.phones">
                <li v-for="phone in contact.phones">
                    <i class="fa fa-phone"></i> <a :href="`tel:${phone.phone}`">{{ phone.phone }}</a> <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="phone.is_primary">Primary</label>
                </li>
            </ul>
            <ul class="list-unstyled mb-0" v-if="contact.addresses">
                <li v-for="address in contact.addresses">
                    <i class="fa fa-globe"></i>
                    {{ address.address }} <br v-if="address.address && address.city" />
                    {{ address.city }}, {{ address.state_id ? address.state.state_name : '' }} {{ address.zip }} <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="address.is_primary">Primary</label>
                </li>
            </ul>

            <hr v-if="i < (contacts.length - 1)" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contacts: {
                type: Array,
                required: true,
            },

            permission: {
                type: String,
                default: "",
            }
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {
            canEdit(){
                return this.$root.hasPermission(this.permission);
            }
        },

        methods: {

        },

        mounted() {

        }
    }
</script>
